import { useQuery } from "@apollo/client";
import {
  GetMeetingNewPageQueryQuery,
  GetMeetingNewPageQueryQueryVariables,
} from "types/graphql-schema";

import MeetingViewSidebar from "@apps/meeting-new/components/meeting-sidebar/meeting-view-sidebar";
import getMeetingQuery from "@apps/meeting-new/graphql/get-meeting-query";
import Layout from "@components/layout/layout";
import Loading from "@components/loading/loading";

// The profile 1-on-1 tab shows the same sidebar as the 1-on-1 meeting page
// (My Notes, Coaching Insights, Work History, Ask AI), scoped to the focused
// meeting. We reuse MeetingViewSidebar directly so the two stay in sync.
const ProfileOneononeSidebar = ({
  meetingId,
  profileId,
  loadingText,
  useRollingWorkHistoryDateRange,
}: {
  meetingId: number | null;
  profileId: number;
  loadingText: string;
  useRollingWorkHistoryDateRange: boolean;
}) => {
  const { data } = useQuery<
    GetMeetingNewPageQueryQuery,
    GetMeetingNewPageQueryQueryVariables
  >(getMeetingQuery, {
    variables: { meetingId: meetingId ?? -1 },
    skip: meetingId === null,
  });
  const meeting = data?.meeting;

  if (!meeting || meeting.subject?.id !== profileId) {
    return (
      <Layout.Sidebar sidebarExpandedUiPreferenceKey="profileSidebarExpanded">
        <Loading className="mt-6">{loadingText}</Loading>
      </Layout.Sidebar>
    );
  }

  return (
    <MeetingViewSidebar
      meeting={meeting}
      sidebarExpandedUiPreferenceKey="profileSidebarExpanded"
      useRollingWorkHistoryDateRange={useRollingWorkHistoryDateRange}
    />
  );
};

export default ProfileOneononeSidebar;
